import styled from "styled-components";

const TipWrapper = styled.span`
  display: inline-block;
  position: relative;
  margin-left: 6px;
  cursor: pointer;
`;

const TipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  background: #222;
  color: #4ad0ac;
  border-radius: 50%;
  font-size: 13px;
  font-weight: bold;
  border: 1px solid #4ad0ac;
  user-select: none;
`;

const TipContent = styled.div`
  display: none;
  position: absolute;
  left: 50%;
  top: -80px;
  transform: translateX(-50%);
  background: #222;
  // color: #fff;
  padding: 6px;
  border-radius: 6px;
  font-size: 12px;
  min-width: 160px;
  max-width: 260px;
  white-space: pre-line;
  word-break: break-word;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);

  ${TipWrapper}:hover & {
    display: block;
  }
`;

export const Tips: React.FC<{ tipText: string }> = ({ tipText }) => (
  <TipWrapper>
    <TipIcon>?</TipIcon>
    <TipContent>{tipText}</TipContent>
  </TipWrapper>
);
